import React from "react";
import logo from "./images/logo512.png";
import ThemeToggle from "./ThemeToggle";

const Header = () => (
  <header className="site-header">
    <div className="wrap site-header-inner">
      <a href="#top" className="wordmark">
        <img alt="" src={logo} />
        elad.hodeda
      </a>
      <nav className="site-nav" aria-label="Primary">
        <a href="#about">About</a>
        <a href="#experience">Experience</a>
        <a href="#skills">Skills</a>
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
        <ThemeToggle />
      </nav>
    </div>
  </header>
);

export default Header;
